/**
 * @fileoverview gRPC-Web generated client stub for scout.message.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v0.0.0
// source: scout/message/v1/message.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.scout = {};
proto.scout.message = {};
proto.scout.message.v1 = require('./message_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.scout.message.v1.MessageServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.scout.message.v1.MessageServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.SendScoutMessageRequest,
 *   !proto.scout.message.v1.SendScoutMessageResponse>}
 */
const methodDescriptor_MessageService_SendScoutMessage = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/SendScoutMessage',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.SendScoutMessageRequest,
  proto.scout.message.v1.SendScoutMessageResponse,
  /**
   * @param {!proto.scout.message.v1.SendScoutMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.SendScoutMessageResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.SendScoutMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.SendScoutMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.SendScoutMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.sendScoutMessage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/SendScoutMessage',
      request,
      metadata || {},
      methodDescriptor_MessageService_SendScoutMessage,
      callback);
};


/**
 * @param {!proto.scout.message.v1.SendScoutMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.SendScoutMessageResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.sendScoutMessage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/SendScoutMessage',
      request,
      metadata || {},
      methodDescriptor_MessageService_SendScoutMessage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.SendScoutMessageForAgentRequest,
 *   !proto.scout.message.v1.SendScoutMessageForAgentResponse>}
 */
const methodDescriptor_MessageService_SendScoutMessageForAgent = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/SendScoutMessageForAgent',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.SendScoutMessageForAgentRequest,
  proto.scout.message.v1.SendScoutMessageForAgentResponse,
  /**
   * @param {!proto.scout.message.v1.SendScoutMessageForAgentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.SendScoutMessageForAgentResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.SendScoutMessageForAgentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.SendScoutMessageForAgentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.SendScoutMessageForAgentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.sendScoutMessageForAgent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/SendScoutMessageForAgent',
      request,
      metadata || {},
      methodDescriptor_MessageService_SendScoutMessageForAgent,
      callback);
};


/**
 * @param {!proto.scout.message.v1.SendScoutMessageForAgentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.SendScoutMessageForAgentResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.sendScoutMessageForAgent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/SendScoutMessageForAgent',
      request,
      metadata || {},
      methodDescriptor_MessageService_SendScoutMessageForAgent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.BulkSendScoutMessageRequest,
 *   !proto.scout.message.v1.BulkSendScoutMessageResponse>}
 */
const methodDescriptor_MessageService_BulkSendScoutMessage = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/BulkSendScoutMessage',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.BulkSendScoutMessageRequest,
  proto.scout.message.v1.BulkSendScoutMessageResponse,
  /**
   * @param {!proto.scout.message.v1.BulkSendScoutMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.BulkSendScoutMessageResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.BulkSendScoutMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.BulkSendScoutMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.BulkSendScoutMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.bulkSendScoutMessage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/BulkSendScoutMessage',
      request,
      metadata || {},
      methodDescriptor_MessageService_BulkSendScoutMessage,
      callback);
};


/**
 * @param {!proto.scout.message.v1.BulkSendScoutMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.BulkSendScoutMessageResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.bulkSendScoutMessage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/BulkSendScoutMessage',
      request,
      metadata || {},
      methodDescriptor_MessageService_BulkSendScoutMessage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.ReserveScoutMessageRequest,
 *   !proto.scout.message.v1.ReserveScoutMessageResponse>}
 */
const methodDescriptor_MessageService_ReserveScoutMessage = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/ReserveScoutMessage',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.ReserveScoutMessageRequest,
  proto.scout.message.v1.ReserveScoutMessageResponse,
  /**
   * @param {!proto.scout.message.v1.ReserveScoutMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.ReserveScoutMessageResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.ReserveScoutMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.ReserveScoutMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.ReserveScoutMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.reserveScoutMessage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/ReserveScoutMessage',
      request,
      metadata || {},
      methodDescriptor_MessageService_ReserveScoutMessage,
      callback);
};


/**
 * @param {!proto.scout.message.v1.ReserveScoutMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.ReserveScoutMessageResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.reserveScoutMessage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/ReserveScoutMessage',
      request,
      metadata || {},
      methodDescriptor_MessageService_ReserveScoutMessage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.ReserveScoutMessageForAgentRequest,
 *   !proto.scout.message.v1.ReserveScoutMessageForAgentResponse>}
 */
const methodDescriptor_MessageService_ReserveScoutMessageForAgent = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/ReserveScoutMessageForAgent',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.ReserveScoutMessageForAgentRequest,
  proto.scout.message.v1.ReserveScoutMessageForAgentResponse,
  /**
   * @param {!proto.scout.message.v1.ReserveScoutMessageForAgentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.ReserveScoutMessageForAgentResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.ReserveScoutMessageForAgentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.ReserveScoutMessageForAgentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.ReserveScoutMessageForAgentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.reserveScoutMessageForAgent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/ReserveScoutMessageForAgent',
      request,
      metadata || {},
      methodDescriptor_MessageService_ReserveScoutMessageForAgent,
      callback);
};


/**
 * @param {!proto.scout.message.v1.ReserveScoutMessageForAgentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.ReserveScoutMessageForAgentResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.reserveScoutMessageForAgent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/ReserveScoutMessageForAgent',
      request,
      metadata || {},
      methodDescriptor_MessageService_ReserveScoutMessageForAgent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.SearchThreadsRequest,
 *   !proto.scout.message.v1.SearchThreadsResponse>}
 */
const methodDescriptor_MessageService_SearchThreads = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/SearchThreads',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.SearchThreadsRequest,
  proto.scout.message.v1.SearchThreadsResponse,
  /**
   * @param {!proto.scout.message.v1.SearchThreadsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.SearchThreadsResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.SearchThreadsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.SearchThreadsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.SearchThreadsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.searchThreads =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/SearchThreads',
      request,
      metadata || {},
      methodDescriptor_MessageService_SearchThreads,
      callback);
};


/**
 * @param {!proto.scout.message.v1.SearchThreadsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.SearchThreadsResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.searchThreads =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/SearchThreads',
      request,
      metadata || {},
      methodDescriptor_MessageService_SearchThreads);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.SearchAgentThreadsRequest,
 *   !proto.scout.message.v1.SearchAgentThreadsResponse>}
 */
const methodDescriptor_MessageService_SearchAgentThreads = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/SearchAgentThreads',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.SearchAgentThreadsRequest,
  proto.scout.message.v1.SearchAgentThreadsResponse,
  /**
   * @param {!proto.scout.message.v1.SearchAgentThreadsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.SearchAgentThreadsResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.SearchAgentThreadsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.SearchAgentThreadsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.SearchAgentThreadsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.searchAgentThreads =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/SearchAgentThreads',
      request,
      metadata || {},
      methodDescriptor_MessageService_SearchAgentThreads,
      callback);
};


/**
 * @param {!proto.scout.message.v1.SearchAgentThreadsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.SearchAgentThreadsResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.searchAgentThreads =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/SearchAgentThreads',
      request,
      metadata || {},
      methodDescriptor_MessageService_SearchAgentThreads);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.GetThreadCommentsRequest,
 *   !proto.scout.message.v1.GetThreadCommentsResponse>}
 */
const methodDescriptor_MessageService_GetThreadComments = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/GetThreadComments',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.GetThreadCommentsRequest,
  proto.scout.message.v1.GetThreadCommentsResponse,
  /**
   * @param {!proto.scout.message.v1.GetThreadCommentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.GetThreadCommentsResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.GetThreadCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.GetThreadCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.GetThreadCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.getThreadComments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/GetThreadComments',
      request,
      metadata || {},
      methodDescriptor_MessageService_GetThreadComments,
      callback);
};


/**
 * @param {!proto.scout.message.v1.GetThreadCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.GetThreadCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.getThreadComments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/GetThreadComments',
      request,
      metadata || {},
      methodDescriptor_MessageService_GetThreadComments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.SendThreadCommentRequest,
 *   !proto.scout.message.v1.SendThreadCommentResponse>}
 */
const methodDescriptor_MessageService_SendThreadComment = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/SendThreadComment',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.SendThreadCommentRequest,
  proto.scout.message.v1.SendThreadCommentResponse,
  /**
   * @param {!proto.scout.message.v1.SendThreadCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.SendThreadCommentResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.SendThreadCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.SendThreadCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.SendThreadCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.sendThreadComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/SendThreadComment',
      request,
      metadata || {},
      methodDescriptor_MessageService_SendThreadComment,
      callback);
};


/**
 * @param {!proto.scout.message.v1.SendThreadCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.SendThreadCommentResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.sendThreadComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/SendThreadComment',
      request,
      metadata || {},
      methodDescriptor_MessageService_SendThreadComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.ReserveThreadCommentRequest,
 *   !proto.scout.message.v1.ReserveThreadCommentResponse>}
 */
const methodDescriptor_MessageService_ReserveThreadComment = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/ReserveThreadComment',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.ReserveThreadCommentRequest,
  proto.scout.message.v1.ReserveThreadCommentResponse,
  /**
   * @param {!proto.scout.message.v1.ReserveThreadCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.ReserveThreadCommentResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.ReserveThreadCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.ReserveThreadCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.ReserveThreadCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.reserveThreadComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/ReserveThreadComment',
      request,
      metadata || {},
      methodDescriptor_MessageService_ReserveThreadComment,
      callback);
};


/**
 * @param {!proto.scout.message.v1.ReserveThreadCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.ReserveThreadCommentResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.reserveThreadComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/ReserveThreadComment',
      request,
      metadata || {},
      methodDescriptor_MessageService_ReserveThreadComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.ReadCommentRequest,
 *   !proto.scout.message.v1.ReadCommentResponse>}
 */
const methodDescriptor_MessageService_ReadComment = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/ReadComment',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.ReadCommentRequest,
  proto.scout.message.v1.ReadCommentResponse,
  /**
   * @param {!proto.scout.message.v1.ReadCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.ReadCommentResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.ReadCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.ReadCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.ReadCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.readComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/ReadComment',
      request,
      metadata || {},
      methodDescriptor_MessageService_ReadComment,
      callback);
};


/**
 * @param {!proto.scout.message.v1.ReadCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.ReadCommentResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.readComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/ReadComment',
      request,
      metadata || {},
      methodDescriptor_MessageService_ReadComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.GetThreadUserRequest,
 *   !proto.scout.message.v1.GetThreadUserResponse>}
 */
const methodDescriptor_MessageService_GetThreadUser = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/GetThreadUser',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.GetThreadUserRequest,
  proto.scout.message.v1.GetThreadUserResponse,
  /**
   * @param {!proto.scout.message.v1.GetThreadUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.GetThreadUserResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.GetThreadUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.GetThreadUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.GetThreadUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.getThreadUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/GetThreadUser',
      request,
      metadata || {},
      methodDescriptor_MessageService_GetThreadUser,
      callback);
};


/**
 * @param {!proto.scout.message.v1.GetThreadUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.GetThreadUserResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.getThreadUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/GetThreadUser',
      request,
      metadata || {},
      methodDescriptor_MessageService_GetThreadUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.message.v1.DeleteReservedCommentRequest,
 *   !proto.scout.message.v1.DeleteReservedCommentResponse>}
 */
const methodDescriptor_MessageService_DeleteReservedComment = new grpc.web.MethodDescriptor(
  '/scout.message.v1.MessageService/DeleteReservedComment',
  grpc.web.MethodType.UNARY,
  proto.scout.message.v1.DeleteReservedCommentRequest,
  proto.scout.message.v1.DeleteReservedCommentResponse,
  /**
   * @param {!proto.scout.message.v1.DeleteReservedCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.message.v1.DeleteReservedCommentResponse.deserializeBinary
);


/**
 * @param {!proto.scout.message.v1.DeleteReservedCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.message.v1.DeleteReservedCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.message.v1.DeleteReservedCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.message.v1.MessageServiceClient.prototype.deleteReservedComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.message.v1.MessageService/DeleteReservedComment',
      request,
      metadata || {},
      methodDescriptor_MessageService_DeleteReservedComment,
      callback);
};


/**
 * @param {!proto.scout.message.v1.DeleteReservedCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.message.v1.DeleteReservedCommentResponse>}
 *     Promise that resolves to the response
 */
proto.scout.message.v1.MessageServicePromiseClient.prototype.deleteReservedComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.message.v1.MessageService/DeleteReservedComment',
      request,
      metadata || {},
      methodDescriptor_MessageService_DeleteReservedComment);
};


module.exports = proto.scout.message.v1;

